/** Darius AbilitySpec seed kit (wiki-aligned numeric batch 2). */
export const DARIUS_ABILITY_DEFS = [
  {
    id: 'darius_q',
    champKey: 'darius',
    slot: 'Q',
    name: 'Decimate',
    targeting: 'aoe_self',
    range: 460,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 460,
    innerRadius: 240,
    cooldown: 9,
    manaCost: 0,
    vfxId: 'darius_q',
    status: 'wired'
  },
  {
    id: 'darius_w',
    champKey: 'darius',
    slot: 'W',
    name: 'Crippling Strike',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 5,
    manaCost: 0,
    vfxId: 'darius_w',
    status: 'wired'
  },
  {
    id: 'darius_e',
    champKey: 'darius',
    slot: 'E',
    name: 'Apprehend',
    targeting: 'skillshot_cone',
    range: 535,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 535,
    cooldown: 26,
    manaCost: 0,
    vfxId: 'darius_e',
    coneAngleRad: 0.8727,
    status: 'wired'
  },
  {
    id: 'darius_r',
    champKey: 'darius',
    slot: 'R',
    name: 'Noxian Guillotine',
    targeting: 'targeted',
    range: 475,
    castTime: 0.367,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 120,
    manaCost: 0,
    vfxId: 'darius_r',
    status: 'wired'
  }
];
